var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfileGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5 25.5238C1.5 23.4699 2.18584 21.5422 3.34653 20.1567C4.50064 18.7791 6.00305 18.0713 7.5 18.0713H22.5C23.997 18.0713 25.4994 18.7791 26.6535 20.1567C27.8142 21.5422 28.5 23.4699 28.5 25.5238C28.5 26.3906 28.2092 27.1797 27.7518 27.7257C27.301 28.2639 26.7524 28.5 26.25 28.5H3.75C3.24761 28.5 2.69903 28.2639 2.24818 27.7257L1.09835 28.689L2.24818 27.7257C1.79076 27.1797 1.5 26.3906 1.5 25.5238Z",
    stroke: "#B8B8B8",
    strokeWidth: 3,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 7C20.5 10.0376 18.0376 12.5 15 12.5C11.9624 12.5 9.5 10.0376 9.5 7C9.5 3.96243 11.9624 1.5 15 1.5C18.0376 1.5 20.5 3.96243 20.5 7Z",
    stroke: "#B8B8B8",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfileGray);
export default __webpack_public_path__ + "static/media/profileGray.be08f19854a7a8b24ec064300df94795.svg";
export { ForwardRef as ReactComponent };